import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  giant: {
    fontFamily: '"Fact Narrow", sans-serif',
    fontWeight: 800,
    fontSize: '164px',
    lineHeight: '180px',
  },
  accent_alt: {
    fontFamily: '"Fact Narrow", sans-serif',
    fontWeight: 800,
    fontSize: '112px',
    lineHeight: '112px',
  },
  accent: {
    fontFamily: '"Fact Condensed", sans-serif',
    fontWeight: 800,
    fontSize: '96px',
    lineHeight: '112px',
  },
  button: {
    fontFamily: '"Fact Semi Expanded", sans-serif',
    fontWeight: 700,
    fontSize: '48px',
    lineHeight: '64px',
    textTransform: 'uppercase',
  },
  button_alt: {
    fontFamily: '"Fact Semi Expanded", sans-serif',
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '56px',
    textTransform: 'uppercase',
  },
  title: {
    fontFamily: '"Fact Narrow", sans-serif',
    fontWeight: 700,
    fontSize: '56px',
    lineHeight: '64px',
  },
  subtitle: {
    fontFamily: '"Fact Narrow", sans-serif',
    fontWeight: 500,
    fontSize: '40px',
    lineHeight: '56px',
    letterSpacing: '2px',
    textTransform: 'uppercase',
  },
  body: {
    fontFamily: '"Fact", sans-serif',
    fontWeight: 700,
    fontSize: '40px',
    lineHeight: '56px',
  },
  description: {
    fontFamily: '"Fact", sans-serif',
    fontWeight: 400,
    fontSize: '40px',
    lineHeight: '56px',
  },
};
